require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#d41028',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        background: '#F8FAFC',
        cards: '#FFFFFF',
      },
      dark: {
        primary: '#d41028',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        background: '#0F172A',
        cards: '#1E293B',
      },
    },
  },
}
